import type { IValidationError } from '../../models/IValidationErrors';
import styles from './ValidationFailedAlert.module.scss';

export interface IValidationFailedAlertProps {
  errors: IValidationError[];
  inputId: string;
}

export default function ValidationFailedAlert({ errors, inputId }: IValidationFailedAlertProps) {
  return (
    <>
      {errors.length > 0 && (
        <div className={styles.errors} id={`${inputId}-errors`} role="alert">
          <ul>
            {errors.map((error) => (
              <li
                key={error.code + error.message.charAt(0)}
                id={`${error.code}-error`}
                className="mb-2"
              >
                {error.message}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
